<template>
        
        <div>
    		<table v-if="!empty" class="order-list">
    			<tbody>
    				
    				<tr 
                        class="order"
                        v-for="(item, index) in store.items" 
                    >
    					<td class="order__image">
    						<a v-bind:href="item.link">
    							<div 
                                    class="order__thumb"
                                    v-bind:style="{ backgroundImage: 'url(\'' + getItemThumb(item) + '\')' }"
                                ></div>
    						</a>
                        </td>
                        <td class="order__name">
                            <input type="hidden" v-bind:name="'product[' + index + '][id]'" v-bind:value="item.id">
                            
                            <a v-bind:href="item.link">
                                {{ item.title }}                  
                            </a>

                            <div v-if="item.selectedOptions" class="order__options">
                                <input 
                                    type="hidden" 
                                    v-for="selectedOption in item.selectedOptions" 
                                    v-bind:name="'product[' + index + '][options][]'" 
                                    v-bind:value="selectedOption.id"
                                >

                                {{ getSelectedOptionTitles(item) }}
                            </div>
    					</td>
    					<td class="order__price">
    						{{ getItemPrice(item) | format_money }} лв.
    					</td>
    					<td class="order__rmv">
                            <a 
                                href="#" 
                                v-on:click.prevent="remove(index)"
                            ></a>
    					</td>
    				</tr>

    		
    				<tr class="order__delivery">
    					<td colspan="2">Доставка</td>
    					<td colspan="2">
                            <span v-if="!totalDeliveryPrice">Безплатна доставка</span>
                            <span v-else>
                                {{ totalDeliveryPrice | format_money }} лв.
                            </span>
                        </td>
    				</tr>

    				<tr class="order__sum">
    					<td colspan="2">Общо</td>
    					<td colspan="2">{{ totalPrice | format_money }} лв.</td>
    				</tr>

    			</tbody>
    		</table>

            <div v-else>
                Няма продукти в количката.
            </div>
        </div>

</template>

<script>
	export default {

        props: [
            "deliveryPrice",
            "freeShippingThreshold",
            "cashOnDeliveryTax"
        ],

        data() {
            return {
                store: CartItems
            };
        },

        computed: {

            empty() {
                return this.store.empty();
            },

            totalPrice() {

                return this.totalProductsPrice ? this.totalProductsPrice + this.totalDeliveryPrice : 0;

            },

            totalProductsPrice() {

                var price = 0;
                var items = this.store.items;

                for (var i = 0, len = items.length; i < len; i++) {
                    price += this.getItemPrice(items[i]);
                }

                return price;

            },


            totalDeliveryPrice() {

                if (typeof this.deliveryPrice === "undefined") {
                    return 0;
                }

                if (this.deliveryPrice == 0 || this.deliveryPrice === null) {
                    return 0;
                }

                if (this.freeShippingThreshold) {
                    var productsPrice = this.totalProductsPrice;

                    if (productsPrice > this.freeShippingThreshold) {
                        return 0;
                    }
                }

                if (this.store.paymentMethod == "cash_on_delivery" && this.cashOnDeliveryTax) {
                    return parseFloat(this.deliveryPrice, 10) + this.totalProductsPrice * parseFloat(this.cashOnDeliveryTax, 10) / 100;
                }

                return parseFloat(this.deliveryPrice, 10);

            },


        },

        methods: {

            remove(index) {
                this.store.remove(index);
            },

            getItemPrice(item) {
                var price = item.promo_price ? parseFloat(item.promo_price, 10) : parseFloat(item.price, 10);

                for (var i = 0, len = item.selectedOptions.length; i < len; i++) {
                    price += parseFloat(item.selectedOptions[i].price, 10);
                }

                return price;
            },

            getItemThumb(item) {

                for (var i = 0; i < item.attachments.length; i++) {
                    if (item.attachments[i].key == "thumb") {
                        return item.attachments[i].path;
                    }
                }

                return null;

            },

            getSelectedOptionTitles: function(item) {

                var result = [];

                for (var i = 0, len = item.selectedOptions.length; i < len; i++) {
                    result.push(item.selectedOptions[i].title);
                }

                return result.join(", ");

            }

            

        },

        watch: {

            totalPrice: function(newValue) {
                this.$emit("change-total-price", newValue);
            }

        },

        mounted() {
            // On component mounted
            this.$emit("change-total-price", this.totalPrice);
        }

    }
</script>